const PREFIX = 'CLEVERTAP_ACTION';

// Bank Accounts
export const CLEVERTAP_BANK_ACCOUNT_OPEN_PAGE = `${PREFIX}_BANK_ACCOUNT_OPEN_PAGE`;
export const CLEVERTAP_BANK_ACCOUNT_VIEW_BANK_ACCOUNT = `${PREFIX}_BANK_ACCOUNT_VIEW_BANK_ACCOUNT`;
export const CLEVERTAP_BANK_ACCOUNT_ADD_BANK_ACCOUNT = `${PREFIX}_BANK_ACCOUNT_ADD_BANK_ACCOUNT`;
export const CLEVERTAP_BANK_ACCOUNT_EDIT_BANK_ACCOUNT = `${PREFIX}_BANK_ACCOUNT_EDIT_BANK_ACCOUNT`;
export const CLEVERTAP_BANK_ACCOUNT_SAVE_NEW_BANK_ACCOUNT = `${PREFIX}_SAVE_NEW_BANK_ACCOUNT`;

// Billings
export const CLEVERTAP_BILLING_OPEN_PAGE = `${PREFIX}_BILLING_OPEN_PAGE`;
export const CLEVERTAP_BILLING_PAY = `${PREFIX}_BILLING_PAY`;

// Table Management
export const CLEVERTAP_TABLE_MANAGEMENT_REPORT_START = `${PREFIX}_TABLE_MANAGEMENT_REPORT_START`;
